export const accountCodingSchema = {
  $id: "/schemas/accountCodingSchema",
  type: "object",
  properties: {
    vendorId: {
      type: "string"
    },
    ediId: {
      type: "string"
    },
    color: {
      type: "string"
    },
    code: {
      type: "string"
    }
  },
  required: []
};
